import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { Box, Toolbar } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import { selectMenu, setDrawerOpen } from "@/redux/features/Setting/Menu/menuSlice";
import Drawer from "./Drawer";
import { useGetProfileQuery } from "@/redux/features/Admin/User/userApi";
import { selectUser, setUserProfile } from "@/redux/features/User/userSlice";

const MainLayout = () => {

  const dispatch = useAppDispatch();

  const user = useAppSelector(selectUser);

  const { drawerOpen } = useAppSelector(selectMenu);
  const [open, setOpen] = useState(drawerOpen);


  const {
    data: userProfile,
    isSuccess
  } = useGetProfileQuery();

  useEffect(() => {
    if (isSuccess && userProfile) {
      dispatch(setUserProfile(userProfile));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, userProfile]);


  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(setDrawerOpen(!open));
  };

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      {
        user.profile && (
          <>
            <Header open={open} handleDrawerToggle={handleDrawerToggle} />
            <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />


            <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
              <Toolbar />
              {
                <Outlet />
              }

            </Box>
          </>
        )
      }
    </Box>
  );
};

export default MainLayout;
